import { useEffect, useState } from 'react';

export function useActiveSection(sectionIds: string[], offset = 120): string {
  const [activeId, setActiveId] = useState(sectionIds[0] ?? 'home');

  useEffect(() => {
    const elements = sectionIds
      .map((id) => document.getElementById(id))
      .filter((element): element is HTMLElement => Boolean(element));

    if (elements.length === 0) {
      return;
    }

    const updateActive = () => {
      const scrollPosition = window.scrollY + offset;
      let current = elements[0].id;

      for (const element of elements) {
        if (element.offsetTop <= scrollPosition) {
          current = element.id;
        }
      }

      setActiveId(current);
    };

    updateActive();
    window.addEventListener('scroll', updateActive, { passive: true });
    window.addEventListener('resize', updateActive);
    return () => {
      window.removeEventListener('scroll', updateActive);
      window.removeEventListener('resize', updateActive);
    };
  }, [sectionIds, offset]);

  return activeId;
}
